export const CREATE_EDIT_PROFILE_SCROLL_ID = 'CREATE_EDIT_PROFILE_SCROLL_ID'

export const MAX_INPUT_LENGTH = 255
export const IGNORE_CHARACTER = ['\\', '/', ':', '*', '?', '"', '<', '>', '|']

export const ERROR_MESSAGE = {
  PROFILE_ALERT_NAME_REQUIRED: 'alertSetting.PROFILE_ALERT_NAME_REQUIRED',
  PROFILE_ALERT_NAME_EXIST: 'alertSetting.PROFILE_ALERT_NAME_EXIST',
}

export const CREATE_PROFILE_TYPE = {
  NEW: 'NEW',
  FROM_EXIST: 'FROM_EXIST',
}

export const EVENT_CRITERIA = {
  FINANCIAL_DISTRESS: {
    key: 'FINANCIAL_DISTRESS',
    alertKey: 'isFinancialDistress',
    emailKey: 'isFinancialDistressSendEmail',
    name: 'alertSetting.criteria.FINANCIAL_DISTRESS',
  },
  BANKRUPTCY: {
    key: 'BANKRUPTCY',
    alertKey: 'isBankruptcy',
    emailKey: 'isBankruptcySendEmail',
    name: 'alertSetting.criteria.BANKRUPTCY',
  },
  FILING_STATUS: {
    key: 'FILING_STATUS',
    alertKey: 'isFilingStatus',
    emailKey: 'isFilingStatusSendEmail',
    name: 'alertSetting.criteria.FILING_STATUS',
  },
  ANALYSIS_AND_CREDIT_RATINGS: {
    key: 'ANALYSIS_AND_CREDIT_RATINGS',
    alertKey: 'isAnalysisAndCreditRatings',
    emailKey: 'isAnalysisAndCreditRatingsSendEmail',
    name: 'alertSetting.criteria.ANALYSIS_AND_CREDIT_RATINGS',
  },
  BUSSINESS_DISRUPTION: {
    key: 'FINANCIAL_DISTRESS',
    alertKey: 'isBussinessDisruption',
    emailKey: 'isBussinessDisruptionSendEmail',
    name: 'alertSetting.criteria.BUSSINESS_DISRUPTION',
  },
  LAWSUIT: {
    key: 'LAWSUIT',
    alertKey: 'isLawsuit',
    emailKey: 'isLawsuitSendEmail',
    name: 'alertSetting.criteria.LAWSUIT',
  },
  LEGAL_VIOLATIONS: {
    key: 'LEGAL_VIOLATIONS',
    alertKey: 'isLegalViolations',
    emailKey: 'isLegalViolationsSendEmail',
    name: 'alertSetting.criteria.LEGAL_VIOLATIONS',
  },
  MANAGEMENT_CHANGES: {
    key: 'MANAGEMENT_CHANGES',
    alertKey: 'isManagementChanges',
    emailKey: 'isManagementChangesSendEmail',
    name: 'alertSetting.criteria.MANAGEMENT_CHANGES',
  },
  CAPITAL_AND_OWNERSHIP_CHANGES: {
    key: 'CAPITAL_AND_OWNERSHIP_CHANGES',
    alertKey: 'isCapitalAndOwnershipChanges',
    emailKey: 'isCapitalAndOwnershipChangesSendEmail',
    name: 'alertSetting.criteria.CAPITAL_AND_OWNERSHIP_CHANGES',
  },
  EARNING_ANNOUNCEMENT: {
    key: 'EARNING_ANNOUNCEMENT',
    alertKey: 'isEarningAnnouncemenet',
    emailKey: 'isEarningAnnouncemenetSendEmail',
    name: 'alertSetting.criteria.EARNING_ANNOUNCEMENT',
  },
  YEARS_OF_OPERATION: {
    key: 'YEARS_OF_OPERATION',
    alertKey: 'isYearsOfOperation',
    emailKey: 'isYearsOfOperationSendEmail',
    name: 'alertSetting.criteria.YEARS_OF_OPERATION',
  },
}

export const SCORE_CRITERIA = {
  CORPORATE_CREDIT_RISK_SCORE: {
    key: 'CORPORATE_CREDIT_RISK_SCORE',
    alertKey: 'isCorpCreRiskScore',
    emailKey: 'isCorpCreRiskScoreSendEmail',
    name: 'alertSetting.criteria.CORPORATE_CREDIT_RISK_SCORE',
  },
  CORPORATE_PERFORMANCE_SCORE: {
    key: 'CORPORATE_PERFORMANCE_SCORE',
    alertKey: 'isCorpPerformanceScore',
    emailKey: 'isCorpPerformanceScoreSendEmail',
    name: 'alertSetting.criteria.CORPORATE_PERFORMANCE_SCORE',
  },
  TRADE_CREDIT_LIMIT_RECOMMENDATION: {
    key: 'TRADE_CREDIT_LIMIT_RECOMMENDATION',
    alertKey: 'isTradeCreditLimitRecommendation',
    emailKey: 'isTradeCreditLimitRecommendationSendEmail',
    name: 'alertSetting.criteria.TRADE_CREDIT_LIMIT_RECOMMENDATION',
  },
}

export const FINANCIAL_CRITERIA = {
  REVENUE_OPERATION_INCOME: {
    key: 'REVENUE_OPERATION_INCOME',
    alertKey: 'isRevenueOperationIncome',
    emailKey: 'isRevenueOperationIncomeSendEmail',
    name: 'alertSetting.criteria.REVENUE_OPERATION_INCOME',
  },
  PROFIT_BEFORE_TAX: {
    key: 'PROFIT_BEFORE_TAX',
    alertKey: 'isProfitBeforeTax',
    emailKey: 'isProfitBeforeTaxSendEmail',
    name: 'alertSetting.criteria.PROFIT_BEFORE_TAX',
  },
}

export const TRACK_COMPANY_RULES_CRITERIA = {
  CHANGE_NAME: {
    key: 'CHANGE_NAME',
    alertKey: 'isChangeName',
    emailKey: 'isChangeNameSendEmail',
    name: 'alertSetting.criteria.CHANGE_NAME',
  },
  CHANGE_LEGAL_FORM: {
    key: 'CHANGE_LEGAL_FORM',
    alertKey: 'isChangeLegalForm',
    emailKey: 'isChangeLegalFormSendEmail',
    name: 'alertSetting.criteria.CHANGE_LEGAL_FORM',
  },
  CHANGE_LEGAL_REPRESENTATIVE: {
    key: 'CHANGE_LEGAL_REPRESENTATIVE',
    alertKey: 'isChangeLegalRepresentative',
    emailKey: 'isChangeLegalRepresentativeSendEmail',
    name: 'alertSetting.criteria.CHANGE_LEGAL_REPRESENTATIVE',
  },
  CHANGE_ACCOUNTING_PERIOD: {
    key: 'CHANGE_ACCOUNTING_PERIOD',
    alertKey: 'isChangeAccountPeriod',
    emailKey: 'isChangeAccountPeriodSendEmail',
    name: 'alertSetting.criteria.CHANGE_ACCOUNTING_PERIOD',
  },
  UPDATE_FINANCIAL_STATEMENT: {
    key: 'UPDATE_FINANCIAL_STATEMENT',
    alertKey: 'isUpdateFinancialStatement',
    emailKey: 'isUpdateFinancialStatementSendEmail',
    name: 'alertSetting.criteria.UPDATE_FINANCIAL_STATEMENT',
  },
}

export const CONDITION = {
  CHANGE_ALL: {
    key: 'CHANGE_ALL',
    value: 1,
    label: 'alertSetting.CHANGE_ALL',
    isI18n: true,
    groupConditionType: '1',
  },
  CHANGE_ACTIVE_TO_OTHERS: {
    key: 'CHANGE_ACTIVE_TO_OTHERS',
    value: 2,
    label: 'alertSetting.CHANGE_ACTIVE_TO_OTHERS',
    isI18n: true,
    groupConditionType: '1',
  },
  CHANGE_ANY_TO_ACTIVE: {
    key: 'CHANGE_ANY_TO_ACTIVE',
    value: 3,
    label: 'alertSetting.CHANGE_ANY_TO_ACTIVE',
    isI18n: true,
    groupConditionType: '1',
  },
  DECREASE_TO: {
    key: 'DECREASE_TO',
    value: 4,
    label: 'alertSetting.DECREASE_TO',
    isI18n: true,
    groupConditionType: '2',
  },
  INCREASE_TO: {
    key: 'INCREASE_TO',
    value: 5,
    label: 'alertSetting.INCREASE_TO',
    isI18n: true,
    groupConditionType: '2',
  },
  GOES_ABOVE: {
    key: 'GOES_ABOVE',
    value: 6,
    label: 'alertSetting.GOES_ABOVE',
    isI18n: true,
    groupConditionType: '2',
  },
  GOES_BELOW: {
    key: 'GOES_BELOW',
    value: 7,
    label: 'alertSetting.GOES_BELOW',
    isI18n: true,
    groupConditionType: '2',
  },
  CHANGES: {
    key: 'CHANGES',
    value: 8,
    label: 'alertSetting.CHANGES',
    isI18n: true,
    groupConditionType: '2',
  },
  CHANGES_IN_VALUE: {
    key: 'CHANGES_IN_VALUE',
    value: 9,
    label: 'alertSetting.CHANGES_IN_VALUE',
    isI18n: true,
    groupConditionType: '3',
  },
  DECREASE_IN_VALUE: {
    key: 'DECREASE_IN_VALUE',
    value: 10,
    label: 'alertSetting.DECREASE_IN_VALUE',
    isI18n: true,
    groupConditionType: '3',
  },
  INCREASE_IN_VALUE: {
    key: 'INCREASE_IN_VALUE',
    value: 11,
    label: 'alertSetting.INCREASE_IN_VALUE',
    isI18n: true,
    groupConditionType: '3',
  },
  CREDIT_ANY_LEVEL: {
    key: 'CREDIT_ANY_LEVEL',
    value: 12,
    label: 'alertSetting.CREDIT_ANY_LEVEL',
    isI18n: true,
    groupConditionType: '4',
  },
  VERY_LOW_RISK: {
    key: 'VERY_LOW_RISK',
    value: 13,
    label: 'alertSetting.VERY_LOW_RISK',
    isI18n: true,
    groupConditionType: '4',
  },
  LOW_RISK: {
    key: 'LOW_RISK',
    value: 14,
    label: 'alertSetting.LOW_RISK',
    isI18n: true,
    groupConditionType: '4',
  },
  MODERATE_RISK: {
    key: 'MODERATE_RISK',
    value: 15,
    label: 'alertSetting.MODERATE_RISK',
    isI18n: true,
    groupConditionType: '4',
  },
  SIGNIFICANT_RISK: {
    key: 'SIGNIFICANT_RISK',
    value: 16,
    label: 'alertSetting.SIGNIFICANT_RISK',
    isI18n: true,
    groupConditionType: '4',
  },
  AGRESSIVE_RISK: {
    key: 'AGRESSIVE_RISK',
    value: 17,
    label: 'alertSetting.AGRESSIVE_RISK',
    isI18n: true,
    groupConditionType: '4',
  },
  PERFORMANCE_ANY_LEVEL: {
    key: 'PERFORMANCE_ANY_LEVEL',
    value: 18,
    label: 'alertSetting.PERFORMANCE_ANY_LEVEL',
    isI18n: true,
    groupConditionType: '5',
  },
  HIGH_GROWTH: {
    key: 'HIGH_GROWTH',
    value: 19,
    label: 'alertSetting.HIGH_GROWTH',
    isI18n: true,
    groupConditionType: '5',
  },
  DECENT_GROWTH: {
    key: 'DECENT_GROWTH',
    value: 20,
    label: 'alertSetting.DECENT_GROWTH',
    isI18n: true,
    groupConditionType: '5',
  },
  MODEST_GROWTH: {
    key: 'MODEST_GROWTH',
    value: 21,
    label: 'alertSetting.MODEST_GROWTH',
    isI18n: true,
    groupConditionType: '5',
  },
  INSIGNIFICANT_GROWTH: {
    key: 'INSIGNIFICANT_GROWTH',
    value: 22,
    label: 'alertSetting.INSIGNIFICANT_GROWTH',
    isI18n: true,
    groupConditionType: '5',
  },
}

export const RULE_TYPE_ID = {
  YEARS_OF_OPERATION: 1,
  CREDIT_RISK_SCORE: 2,
  PERFORMANCE_SCORE: 3,
  TRADE_CREDIT_LIMIT: 4,
  REVENUE_OPERATION_INCOME: 5,
  PROFIT_BEFORE_TAX: 6,
}

export const GROUP_CONDITION = {
  YEARS_OF_OPERATION: '1',
  CREDIT_RISK_SCORE: '2',
  PERFORMANCE_SCORE: '2',
  TRADE_CREDIT_LIMIT: '3',
  REVENUE_OPERATION_INCOME: '3',
  PROFIT_BEFORE_TAX: '3',
}

export const THRESHOLD_GROUP_CONDITION = {
  CREDIT_RISK_SCORE: '4',
  PERFORMANCE_SCORE: '5',
}

export const OPERATION_OPTIONS = Object.values(CONDITION).filter(
  (item) => item.groupConditionType === GROUP_CONDITION.YEARS_OF_OPERATION,
)

export const CREDIT_RISK_SCORE_OPTIONS = Object.values(CONDITION).filter(
  (item) => item.groupConditionType === GROUP_CONDITION.CREDIT_RISK_SCORE,
)

export const PERFORMANCE_SCORE_OPTIONS = Object.values(CONDITION).filter(
  (item) => item.groupConditionType === GROUP_CONDITION.PERFORMANCE_SCORE,
)

export const TRADE_CREDIT_LIMIT_OPTIONS = Object.values(CONDITION).filter(
  (item) => item.groupConditionType === GROUP_CONDITION.TRADE_CREDIT_LIMIT,
)

export const CREDIT_RISK_THRESHOLD_OPTIONS = Object.values(CONDITION).filter(
  (item) =>
    item.groupConditionType === THRESHOLD_GROUP_CONDITION.CREDIT_RISK_SCORE,
)

export const PERFORMANCE_THRESHHOLD_OPTIONS = Object.values(CONDITION).filter(
  (item) =>
    item.groupConditionType === THRESHOLD_GROUP_CONDITION.PERFORMANCE_SCORE,
)

export const REVENUE_OPERATION_OPTIONS = Object.values(CONDITION).filter(
  (item) =>
    item.groupConditionType === GROUP_CONDITION.REVENUE_OPERATION_INCOME,
)

export const PROFIT_BEFORE_TAX_OPTIONS = Object.values(CONDITION).filter(
  (item) => item.groupConditionType === GROUP_CONDITION.PROFIT_BEFORE_TAX,
)

export const DEFAULT_PROFILE_SCORE = [
  {
    ruleTypeId: RULE_TYPE_ID.YEARS_OF_OPERATION,
    condition: CONDITION.CHANGE_ALL.value,
  },
  {
    ruleTypeId: RULE_TYPE_ID.CREDIT_RISK_SCORE,
    condition: CONDITION.CHANGES.value,
    threshold: null,
  },
  {
    ruleTypeId: RULE_TYPE_ID.PERFORMANCE_SCORE,
    condition: CONDITION.CHANGES.value,
    threshold: null,
  },
  {
    ruleTypeId: RULE_TYPE_ID.TRADE_CREDIT_LIMIT,
    condition: CONDITION.CHANGES_IN_VALUE.value,
  },
  {
    ruleTypeId: RULE_TYPE_ID.REVENUE_OPERATION_INCOME,
    condition: CONDITION.CHANGES_IN_VALUE.value,
  },
  {
    ruleTypeId: RULE_TYPE_ID.PROFIT_BEFORE_TAX,
    condition: CONDITION.CHANGES_IN_VALUE.value,
  },
]

export const EVENT_RULES_COL = {
  SWITCH: 'SWITCH',
  EVENT: 'EVENT',
  SEND_EMAILS: 'SEND_EMAILS',
}

export const SCORE_RULES_COL = {
  SWITCH: 'SWITCH',
  SCORE: 'SCORE',
  CONDITION: 'CONDITION',
  THRESHOLD: 'THRESHOLD',
  SEND_EMAILS: 'SEND_EMAILS',
}

export const FINANCIAL_RULES_COL = {
  SWITCH: 'SWITCH',
  FINANCIAL_INDICATOR: 'name',
  CONDITION: 'CONDITION',
  SEND_EMAILS: 'SEND_EMAILS',
}

export const PORTFOLIOS_COL = {
  PORTFOLIOS: 'portfolioName',
  DELETE: 'DELETE',
}

export const TRACK_COMPANY_RULES_COL = {
  EVENT: 'name',
  SEND_EMAILS: 'SEND_EMAILS',
}
